import { SET_USER_LOCATION } from './constants';

export const setLocation = (address) => {
  return {
    type: SET_USER_LOCATION,
    payload: address,
  };
}